var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseDownWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.056 12C11.8842 12.0004 11.7178 11.9387 11.586 11.8258L3.33602 4.90934C3.09818 4.74802 2.97023 4.46243 3.00588 4.17246C3.04153 3.88249 3.23461 3.63834 3.50407 3.54251C3.77353 3.44667 4.07271 3.51575 4.27602 3.72073L12.056 10.2068L19.836 3.72073C20.1581 3.50226 20.5895 3.5702 20.8327 3.87772C21.0759 4.18524 21.0514 4.63173 20.776 4.90934L12.526 11.8258C12.3942 11.9387 12.2278 12.0004 12.056 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.056 20.5C11.8842 20.5004 11.7178 20.4387 11.586 20.3258L3.33602 13.4093C3.09818 13.248 2.97023 12.9624 3.00588 12.6725C3.04153 12.3825 3.23461 12.1383 3.50407 12.0425C3.77353 11.9467 4.07271 12.0157 4.27602 12.2207L12.056 18.7068L19.836 12.2207C20.1581 12.0023 20.5895 12.0702 20.8327 12.3777C21.0759 12.6852 21.0514 13.1317 20.776 13.4093L12.526 20.3258C12.3942 20.4387 12.2278 20.5004 12.056 20.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseDownWhite);
export default __webpack_public_path__ + "static/media/CollapseDownWhite.3330f9ff81bffb7e79a2d96b3ccd2f3f.svg";
export { ForwardRef as ReactComponent };